import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLayoutColumnItemBreakAfters, EGDSLayoutColumnItemBreakBefores, EGDSLayoutColumnItemBreakInsides, EGDSLayoutColumnItemSpans } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-layout-columns.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutColumnsItem = props => {
  const {
    breakAfter,
    breakBefore,
    breakInside,
    children,
    className,
    columnSpan,
    forceNoBreak,
    style
  } = props;
  const childrenArray = React.Children.toArray(children);
  if (!childrenArray.length) {
    return null;
  }
  const firstChild = childrenArray[0];
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-columns-item';
  const wrapperClassNames = getClassNameList(baseClass, firstChildClassName, breakAfter && `${baseClass}-${EGDSLayoutColumnItemBreakAfters.get(breakAfter)}`, breakBefore && `${baseClass}-${EGDSLayoutColumnItemBreakBefores.get(breakBefore)}`, breakInside && `${baseClass}-${EGDSLayoutColumnItemBreakInsides.get(breakInside)}`, columnSpan && `${baseClass}-${EGDSLayoutColumnItemSpans.get(columnSpan)}`, forceNoBreak && `${baseClass}-force-no-break`, className);
  const wrapperStyle = {
    ...firstChildStyle,
    ...style
  };
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    ...(Object.keys(wrapperStyle).length && {
      style: wrapperStyle
    })
  });
  return decoratedChild;
};
export { EGDSLayoutColumnsItem };